export enum ERoles {
	ROLE_MANAGER = "ROLE_MANAGER",
	ROLE_PATHWAYS_MANAGER = "ROLE_PATHWAYS_MANAGER",
	ROLE_QUALITY = "ROLE_QUALITY",
	ROLE_ADMIN_DIRECTORY = "ROLE_ADMIN_DIRECTORY",
	ROLE_ADMIN_CALC = "ROLE_ADMIN_CALC",
	ROLE_ADMIN_DIRECTORY_FULL = "ROLE_ADMIN_DIRECTORY_FULL",
	ROLE_ADMIN_USERS_FULL = "ROLE_ADMIN_USERS_FULL",
	ROLE_ADMIN_NOTIFICATIONS = "ROLE_ADMIN_NOTIFICATIONS",
	ROLE_SERVER = "ROLE_SERVER",
	ROLE_ADMIN_STATISTICS = "ROLE_ADMIN_STATISTICS",
	ROLE_ADMIN_BACKUP = "ROLE_ADMIN_BACKUP",
	ROLE_ADMIN_CATALOG = "ROLE_ADMIN_CATALOG",
	ROLE_MANAGER_CATALOG = "ROLE_MANAGER_CATALOG",
	ROLE_PACKAGES = "ROLE_PACKAGES",
	ROLE_SWITCH_USER = "ROLE_SWITCH_USER",
	ROLE_CONTACT = "ROLE_CONTACT",
	ROLE_ADMIN_PROTOCOL_FINGERPRINT = "ROLE_ADMIN_PROTOCOL_FINGERPRINT",
	ROLE_SUPREME_ADMIN = "ROLE_SUPREME_ADMIN",
	ROLE_PHARMACY = "ROLE_PHARMACY",
	ROLE_CODER = "ROLE_CODER",
	ROLE_EDUCATION_MANAGER = "ROLE_EDUCATION_MANAGER",
	ROLE_EDUCATION_STUDENT = "ROLE_EDUCATION_STUDENT",
	ROLE_EXPERT = "ROLE_EXPERT",
	ROLE_HELP_AUTHOR = "ROLE_HELP_AUTHOR",
}
